module.exports = __webpack_public_path__ + "static/img/001.f1959e27.png";